import {
  CreateManifest,
  GetAutoPayDetails,
  Confirmation,
  CancelMembershipAutoPay,
  GetDiscount,
} from './contracts';
import { endpoints } from './endpoints';
import * as remote from './remotes';
import * as stub from './stubs';

type Sources = {
  createManifest: CreateManifest;
  getAutoPayDetails: GetAutoPayDetails;
  confirmation: Confirmation;
  cancelMembershipAutoPay: CancelMembershipAutoPay;
  getDiscount: GetDiscount;
};

const stubs: Sources = {
  createManifest: stub.CreateManifestStub,
  getAutoPayDetails: stub.GetAutoPayDetailsStub,
  confirmation: stub.ConfirmationStub,
  cancelMembershipAutoPay: stub.CancelMembershipAutoPayStub,
  getDiscount: stub.GetDiscountStub,
};

const remotes: Sources = {
  createManifest: remote.CreateManifestApi(endpoints.createManifest),
  getAutoPayDetails: remote.GetAutoPayDetailsApi(endpoints.getAutoPayDetails),
  confirmation: remote.ConfirmationApi(endpoints.confirmation),
  cancelMembershipAutoPay: remote.CancelMembershipAutoPayApi(endpoints.cancelMembershipAutoPay),
  getDiscount: remote.GetDiscountApi(endpoints.getDiscount),
};

export const sources = import.meta.env.VITE_ENV === 'local' ? stubs : remotes;
